export default __webpack_public_path__ + "static/logo_ja-bb4b07ec5ff2c7a39c1ac3a445f3d060.png";